import NewApiKeyForm from './NewApiKeyForm'

export default NewApiKeyForm
